import { fontsize24, poppins400, poppins500 } from 'theme/common.style';

export const contentBox = {
  backgroundColor: '#F8F8F8',
  padding: '15px',
  borderRadius: '10px',
  minWidth: '49%',
};
export const detailsBox = {
  padding: '7px',
  display: 'flex',
  alignItem: 'start',
  borderBottom: '1px solid #C4C4C4',
};
export const detailsLabel = {
  ...poppins500,
  fontSize: '20px',
  width: '50%',
};

export const detailsValue = {
  ...poppins400,
  fontSize: '20px',
  color: '#666666',
};

export const specView = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const auctionData = {
  padding: '20px 0px',
  display: 'flex',
  alignItems: 'center',
};
export const specViewHours = {
  display: 'flex',
  alignAitems: 'center',
  color: 'red',
  fontSize: '18px',
  fontWeight: 400,
  gap: '8px',
};
export const specViewPropert = {
  color: '#666666',
  fontSize: '18px',
  fontWeight: 400,
  ...poppins400,
};
export const iconText = {
  alignItems: 'center',
};

export const mortGridValue = {
  ...poppins400,
  ...fontsize24,
  color: '#666666',
  textAlign: 'end',
};

export const mortColorCont = (color) => ({
  border: `1px solid ${color}`,
  padding: '10px 20px',
  height: '12px',
  borderRadius: '5px',
  width: '39px',
  backgroundColor: `${color}`,
});

export const underlineText = {
  borderBottom: '1px solid #C4C4C4',
  margin: '0px 0px 0px 56px',
  padding: '10px 0px',
};
